<a class="skip-link" href="#main-content">{{ "common.skipToMain" | transloco }}</a>

<router-outlet></router-outlet>

<ail-webinar-prepare-loader></ail-webinar-prepare-loader>

@if (assistantUrl()) {
  <app-assistant-chatbot [url]="assistantUrl()"></app-assistant-chatbot>
}

<ng-template #userIdleContainer let-c="close" let-d="dismiss">
  <header>
    <span>{{ "shell.inactivity.title" | transloco }}</span>
    <button
      (click)="d('Cross click')"
      [attr.aria-label]="'shell.inactivity.closeAria' | transloco"
      type="button"
      style="background:none;border:none;cursor:pointer;font-size:1.25rem;line-height:1;color:var(--q-text-m,#475569);opacity:0.6;"
    >&times;</button>
  </header>
  <div class="modal-body-content">
    <p style="margin:0;font-size:0.9rem;color:var(--q-text-m,#475569);">{{ "shell.inactivity.body" | transloco }}</p>
  </div>
  <footer>
    <button type="button" class="button-outline" (click)="logout()">{{ "shell.inactivity.logout" | transloco }}</button>
    <button type="button" class="button-primary" (click)="keepOpen()">{{ "shell.inactivity.stayLoggedIn" | transloco }}</button>
  </footer>
</ng-template>
